import { Box } from "@mui/material";
import { BorderLinearProgress, StorageContainer } from "./styles";
import { UserDetailsContext } from "../../contexts";
import { useContext, useEffect, useState } from "react";
import { tierStorageMap } from "../../pages/Billing/types";
import { formatFileSize } from "../../services/trackService";

const StorageComponent: React.FC = () => {
  const { storageUsage, subscriptionTier } = useContext(UserDetailsContext);
  const [totalStorage, setTotalStorage] = useState(0);

  useEffect(() => {
    if (subscriptionTier)
      setTotalStorage(tierStorageMap[subscriptionTier].storageValue);
  }, [subscriptionTier, storageUsage]);

  return (
    <StorageContainer>
      <Box sx={{ marginX: 1, display: "flex" }}>
        <Box sx={{ flexGrow: 1 }}>Storage</Box>
        <Box>{`${formatFileSize(storageUsage)} of ${formatFileSize(
          totalStorage
        )} used`}</Box>
      </Box>
      <BorderLinearProgress
        variant="determinate"
        value={(storageUsage / totalStorage) * 100}
        sx={{ marginTop: 1, marginBottom: 2 }}
      />
    </StorageContainer>
  );
};

export default StorageComponent;
